import React from 'react';
import { CloseSmall } from '@icon-park/react';
import { BUSINESS_CONFIG } from '../../../config';

function ShareModal({ isOpen, shareLink, createdId, onClose }) {
  if (!isOpen) return null;

  const qrSrc = createdId
    ? `/api/foodlabel/labels/${createdId}/qrcode`
    : `https://api.qrserver.com/v1/create-qr-code/?size=${BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}x${BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}&ecc=${BUSINESS_CONFIG.QRCODE.ERROR_CORRECTION_LEVEL}&data=${encodeURIComponent(shareLink || '')}`;

  const downloadHref = createdId
    ? `/api/foodlabel/labels/${createdId}/qrcode`
    : `https://api.qrserver.com/v1/create-qr-code/?size=${BUSINESS_CONFIG.QRCODE.DOWNLOAD_SIZE}x${BUSINESS_CONFIG.QRCODE.DOWNLOAD_SIZE}&ecc=${BUSINESS_CONFIG.QRCODE.ERROR_CORRECTION_LEVEL}&data=${encodeURIComponent(shareLink || '')}`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <CloseSmall theme="outline" size={18} />
        </button>
        <h2 className="modal-title">保存成功</h2>
        <p className="modal-subtitle">已生成公开页面与二维码，可下载二维码图片</p>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <img
            src={qrSrc}
            alt="分享二维码"
            width={BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}
            height={BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}
            style={{ border: '1px solid #e8eaed', borderRadius: 8, background: '#fff' }}
            onError={(e) => {
              const size = BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE;
              const ecc = BUSINESS_CONFIG.QRCODE.ERROR_CORRECTION_LEVEL;
              e.currentTarget.src = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&ecc=${ecc}&data=${encodeURIComponent(shareLink || '')}`;
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <a
              className="btn-template"
              href={downloadHref}
              download={`label-${createdId || 'preview'}-qrcode.png`}
            >
              下载二维码
            </a>
          </div>
        </div>

        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <button className="btn-close" onClick={onClose}>完成</button>
        </div>
      </div>
    </div>
  );
}

export default ShareModal;
